var map = {
	"./music-instructions.json": 3560,
	"./music-library-intro2024.json": 3561,
	"./music-library-launch2024.json": 3562,
	"./music-progression.json": 3563,
	"./startSourcesAdvanced.json": 3564,
	"./startSourcesSimple.json": 3565,
	"./startSourcesSimple2.json": 3566,
	"./startSourcesTracks.json": 3567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3418;